export enum ModalActionsEnum {
  ON = "ON",
  OFF = "OFF",
  ERROR = "ERROR"
}

type ModalReducerState = {
  show: boolean;
  name: string | null;
  data?: unknown | null;
  error?: string | null;
};

type ModalReducerAction = {
  type: ModalActionsEnum;
  payload: ModalReducerState;
};

export const modalInitialState = {
  show: false,
  name: null,
  data: null,
  error: null
};

export function modalReducer(
  state: ModalReducerState,
  action: ModalReducerAction
): ModalReducerState {
  const { name, data, error } = action?.payload || {};

  switch (action.type) {
    case "ON":
      return {
        show: true,
        name,
        data,
        error
      };
    case "OFF":
      return modalInitialState;
    case "ERROR":
      return {
        show: true,
        name,
        data: null,
        error
      };
    default:
      throw new Error();
  }
}
